module.exports = __webpack_public_path__ + "static/media/the-english-riviera.82811ff1.jpg";